import { useParams } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubCommitCrumb(props: Partial<BreadcrumbData>) {
  const { commit } = useParams();
  const organizationId = useOrganizationId();
  const innerPath =
    props.path === '#' ? '#' : addQueryParams(props.path, { organizationId });
  return (
    <>
      {commit && <Breadcrumb name={commit.substring(0, 8)} path={innerPath} />}
    </>
  );
}
